import axios from "../utils/axios";

type DataType = {
  text: string;
  source_language_code: string;
  target_language_code: string;
}

export function translateText(data: DataType, token: string) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/deepl-translate/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
